import React, { useContext } from "react";
import google from "../../../../../images/LandingPageImage/google.png";
import Ornament from "../../../../../images/LandingPageImage/Ornament.svg";
import Navbar from "../../common/Navbar";
import FAQContactSection from "../FAQContactSection";
import CallToAction from "../CallToAction";
import template from "../../../../../images/LandingPageImage/template.png";
import Footer from "../../common/Footer";
import { Link } from "react-router-dom";
import MyContext from "../../../../../MyContext";

export default function AutomatedReplies() {
  const { openFreeTrialModal } = useContext(MyContext);

  return (
    <div>
      <div
        className="hero-bg pt-4 pt-md-5 overflow-hidden font-inter"
        style={{ minHeight: "90vh" }}
      >
        <Navbar />

        <div className="container mt-4 mt-lg-5 mb-5">
          <div className="row align-items-center justify-content-center">
            <div className="col-12 col-lg-6 px-3 px-md-4 order-2 order-lg-1 text-center text-lg-start mt-4 mt-lg-0">
              <h1 className="display-6 display-md-5 fw-semibold font-bricolage mb-3 mb-md-4 lh-sm text-white">
                Automated Replies & Smart Flows:{" "}
                <br className="d-none d-md-block" />
                Smarter Conversations on <br className="d-none d-md-block" />
                <span style={{ color: "yellowgreen" }}>WhatsApp</span>
              </h1>

              <p
                className="small text-light opacity-90 mb-4 fw-light mx-auto mx-lg-0"
                style={{ maxWidth: "550px", lineHeight: "1.7" }}
              >
                In today’s fast-moving digital world, customers expect instant
                replies and smooth, guided conversations. Automated smart flows
                ensure your business is active 24/7, turning delayed responses
                into instant engagement and missed leads into loyal customers.
              </p>

              <div className="d-flex flex-column flex-sm-row justify-content-center justify-content-lg-start gap-3 mt-4">
                <Link to="/login" className="text-decoration-none">
                  <button
                    type="button"
                    className="btn btn-outline-google rounded-pill fw-semibold d-flex align-items-center justify-content-center gap-2 px-4 py-2"
                    style={{ minHeight: "48px" }}
                  >
                    <span
                      className="rounded-circle bg-white d-flex align-items-center justify-content-center"
                      style={{ width: "28px", height: "28px" }}
                    >
                      <img
                        src={google}
                        alt="Google"
                        style={{ width: "16px" }}
                      />
                    </span>
                    <span className="text-nowrap">Start With Google</span>
                  </button>
                </Link>

                <button
                  onClick={openFreeTrialModal}
                  className="btn btn-outline-demo rounded-pill px-4 py-2 fw-semibold d-flex align-items-center justify-content-center"
                  style={{ minHeight: "48px" }}
                >
                  Book a Demo
                </button>
              </div>
            </div>

            <div className="col-12 col-lg-6 mb-5 mb-lg-0 order-2 order-lg-2">
              <div className="position-relative d-flex align-items-center justify-content-center p-2 p-md-3">
                <img
                  src={Ornament}
                  className="img-fluid floating-animation"
                  alt="Background"
                  style={{ opacity: "0.4", filter: "blur(15px)", width: "80%" }}
                />

                <img
                  src={template}
                  alt="automation_flows"
                  className="position-absolute img-fluid main-image-hover"
                  style={{
                    maxWidth: "85%",
                    height: "auto",
                    zIndex: 2,
                    filter: "drop-shadow(0px 15px 35px rgba(0,0,0,0.4))",
                  }}
                />
              </div>
            </div>
          </div>
        </div>

       <style>{`
  @media (max-width: 767.98px) {
    .display-6 {
      font-size: 1.85rem !important;
    }
  }

  .main-image-hover {
    transition: all 0.4s ease-in-out;
  }

  .main-image-hover:hover {
    transform: scale(1.02) translateY(-10px);
  }

  @keyframes float {
    0%, 100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-20px);
    }
  }

  .floating-animation {
    animation: float 6s ease-in-out infinite;
  }
`}</style>

      </div>
      <section className="min-vh-100 d-flex who-bg align-items-center font-inter py-5 px-3">
        <div
          className="container mx-auto text-center"
          style={{ maxWidth: "1050px" }}
        >
          <h2 className="fs-2 fw-semibold font-bricolage text-white mb-4">
            What Are Automated Replies and Smart Flows?
          </h2>

          <div className="mb-5 px-md-5 mx-auto" style={{ maxWidth: "900px" }}>
            <p className="fs-6 opacity-90 mb-4 fw-light lh-lg text-yellowgreen">
              Automated replies are pre-set messages that are sent automatically
              when a user takes an action, such as sending a message or clicking
              a button. Smart flows take this further by creating structured
              conversation paths that adapt based on user responses.
            </p>
          </div>

          <div className="row g-2 g-lg-3 justify-content-center mt-2">
            <div className="col-12 col-md-6 col-lg-6">
              <div
                className="glass-card h-100 p-3 p-md-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg transition-all hover-effect"
                style={{
                  background:
                    "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
                }}
              >
                <h3 className="h5 fw-bold mb-3 text-yellowgreen font-bricolage">
                  Why Automation Matters in WhatsApp Communication
                </h3>
                <p className="text-white opacity-75 fw-light lh-base">
                  As customer interactions increase, manual replies become
                  difficult to manage. Automation ensures every query is handled
                  instantly and consistently, even outside business hours. With
                  smart automation, businesses can improve response speed,
                  reduce support load, maintain consistent messaging.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-6">
              <div
                className="glass-card h-100 p-3 p-md-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg transition-all hover-effect"
                style={{
                  background:
                    "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
                }}
              >
                <h3 className="h5 fw-bold mb-3 text-yellowgreen font-bricolage">
                  SendBulkMsg Powers Smart Automation
                </h3>
                <p className="text-white opacity-75 fw-light lh-base">
                  SendBulkMsg offers powerful automation features designed to
                  simplify WhatsApp communication for businesses across
                  industries. The platform allows businesses to set up instant
                  replies for common questions, design multi-step smart flows
                  with buttons and quick replies, and route conversations based
                  on user choices.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="min-vh-100 d-flex who-bg align-items-center font-inter py-5 px-3">
        <div
          className="container mx-auto text-center"
          style={{ maxWidth: "1150px" }}
        >
          <h2 className="fs-2 fw-bold font-bricolage text-white mb-4">
            Why Choose SendBulkMsg for WhatsApp Automation?
          </h2>

          <div className="mb-5 px-md-5 mx-auto" style={{ maxWidth: "900px" }}>
            <p className="fs-6 opacity-90 mb-4 fw-light lh-lg text-yellowgreen">
              SendBulkMsg is built to help businesses work smarter, not harder.
              By combining automation, analytics, and ease of use in one
              platform, it enables brands to deliver fast, reliable, and
              meaningful WhatsApp conversations at scale.
            </p>
          </div>

          <div className="row g-4 justify-content-center mt-2">
            <div className="col-12 col-md-3">
              <div
                className="glass-card h-100 p-4 p-md-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg transition-all hover-effect"
                style={{
                  background:
                    "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
                }}
              >
                <h3 className="h6 fw-bold mb-3 text-yellowgreen font-bricolage">
                  Instant Replies, Always Available
                </h3>
                <p className="text-white opacity-75 fw-light small lh-base">
                  Respond to customer queries 24/7 with automated replies that
                  keep conversations moving and never leave users waiting.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-3">
              <div
                className="glass-card h-100 p-4 p-md-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg transition-all hover-effect"
                style={{
                  background:
                    "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
                }}
              >
                <h3 className="h6 fw-bold mb-3 text-yellowgreen font-bricolage">
                  Guided Conversations That Convert
                </h3>
                <p className="text-white opacity-75 fw-light small lh-base">
                  Smart flows help guide users through structured interactions,
                  making it easier to qualify leads, answer questions, and drive
                  conversions effortlessly.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-3">
              <div
                className="glass-card h-100 p-4 p-md-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg transition-all hover-effect"
                style={{
                  background:
                    "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
                }}
              >
                <h3 className="h6 fw-bold mb-3 text-yellowgreen font-bricolage">
                  Reduced Manual Effort, Faster Responses
                </h3>
                <p className="text-white opacity-75 fw-light small lh-base">
                  Automated replies and smart flows handle routine questions
                  instantly, reducing support workload and allowing teams to
                  focus on high-value customer interactions.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-3">
              <div
                className="glass-card h-100 p-4 p-md-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg transition-all hover-effect"
                style={{
                  background:
                    "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
                }}
              >
                <h3 className="h6 fw-bold mb-3 text-yellowgreen font-bricolage">
                  Consistent Messaging at Every Touchpoint
                </h3>
                <p className="text-white opacity-75 fw-light small lh-base">
                  Deliver accurate, on-brand responses every time with
                  predefined flows, ensuring customers receive clear and
                  reliable information throughout the conversation.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FAQContactSection />
      <CallToAction />
      <Footer />
    </div>
  );
}
